import axios from 'axios'

const state = () => ({
  users: [],
  user: {},
})

const getters = {
  getUsers: (state) => state.users,
}

const actions = {
  async getUsers({ rootState, commit }) {
    const response = await axios.get(rootState.api + '/users', {
      headers: {
        Authorization: 'Bearer ' + rootState.apiToken,
      },
    })

    commit('setUsers', response.data)
  },
  async deleteUser({ rootState }, { id }) {
    await axios.delete(rootState.api + '/users/' + id, {
      headers: {
        Authorization: 'Bearer ' + rootState.apiToken,
      },
    })
  },
}

const mutations = {
  setUsers(state, payload) {
    state.users = payload
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
